import {
  CLEAR_FORM,
  DELETE_PRODUCT,
  GET_PRODUCT_DETAILS,
  GET_PRODUCT_LIST,
  SET_FORM,
} from "../constant/Type";

const initialState = {
  form: {},
  loading: true,
};

const formReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_FORM:
      return {
        ...state,
        form: { ...state.form, ...payload },
        loading: false,
      };
    case CLEAR_FORM:
      return {
        ...state,
        form: {},
        loading: false,
      };

    default:
      return state;
  }
};

export default formReducer;
